export default {
  // 'Welcome!': 'Välkommen!',
  // 'Joint ID': 'Skarv-ID',
  // 'ID': 'ID',
  // 'Alarm': 'Alarm',
  // 'Joints': 'Skarvar',
  // 'Current Report': 'Valda rapportrader',
  // 'Current Equipment': 'Nuvarande hyrd utrustning',
  // 'Equipment': 'Utrustning',
  // ' Equipment': 'Utrustning',
  // 'Timestamp': 'Tidsstämpel',
  // 'Actions': 'Åtgärder',
  // 'Report Preview': 'Förhandsgranska',
  // 'Page:': 'Sida:',
  // 'Filters': 'Filter',
  // 'January_February_March_April_May_June_July_August_September_October_November_December': 'Januari_Februari_Mars_April_Maj_Juni_Juli_Augusti_September_Oktober_November_December',
  // 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec',
  // 'Mo_Tu_We_Th_Fr_Sa_Su': 'Må_Ti_On_To_Fr_Lö_Sö',
  // 'Previous': 'Föregående',
  // 'Reloading data..': 'Uppdaterar tabellen..',
  // 'Data reloaded': 'Tabellen uppdaterad',
  // 'Add to report': 'Lägg till i rapport',
  // 'Next': 'Nästa',
  // 'Rental Start Date': 'Startdatum hyrperiod',
  // 'Rental End Date': 'Slutdatum hyrperiod',
  // 'Map': 'Karta',
  // 'Password': 'Lösenord',
  // 'The password is required!': 'Vänligen ange lösenord!',
  // 'Password must be at least {1} characters': 'Lösenordet måste vara minst {1} tecken',
  // 'Create User': 'Skapa användare',
  // 'First Name': 'Förnamn',
  // 'Last Name': 'Efternamn',
  // 'E-mail': 'E-post',
  // 'User list': 'Användare',
  // 'Create new user': 'Skapa ny användare',
  // 'Edit': 'Redigera',
  // 'Delete': 'Radera',
  // 'User Profile': 'Användarprofil',
  // 'Save': 'Spara',
  // 'User Companies': 'Företagsbehörigheter',
  // 'Select companies': 'Välj företag',
  // 'Save Companies': 'Spara företag',
  // 'Welding Report': 'Svetsrapport',
  // 'Created by:': 'Skapad av:',
  // 'Company:': 'Företag:',
  // 'of': 'av',
  // 'Remove': 'Radera',
  // 'Clear Report': 'Rensa allt',
  // 'Preview Report': 'Förhandsgranska',
  // 'Print Report': 'Skriv ut',
  // 'Are you sure?': 'Är du säker?',
  // 'Sign In to your account': 'Logga in nedan för att komma åt MittLog-portalen.',
  // 'Email': 'E-post',
  // 'Forgot password?': 'Glömt lösenordet?',
  // 'Logging in..': 'Loggar in..',
  // 'Access Denied': 'Inloggning misslyckades',
  // 'Map (Only shows welding machines)': 'Karta (Visar endast svetsmaskiner)',
  // 'All': 'Alla',
  // 'Machine ID': 'Maskin-ID',
  // 'icon-110': 'icon-power',
  // 'Ongoing': 'Pågående',
  // 'Historical equipment rentals': 'Tidigare hyrd utrustning',
  // 'On': 'På',
  // 'Off': 'Av',
  // 'Equipment ID (If applicable)': '',
  // 'Description': '',
  // 'Write a description of what happened..': '',
  // 'Alert customer to send back equipment': '',
  // 'Date': 'Datum',
  // 'Reason': 'Anledning',
  // 'Created by': 'Skapad av',
  // 'Customer Log': 'Kundlogg',
  // 'Create Log Entry': '',
  // 'Support - Phone': 'Support - Telefon',
  // 'Support - E-mail': 'Support - Mejl',
  // 'Sales - Phone': 'Säljsamtal - Telefon',
  // 'Sales Activity - Campaign, Email etc.': 'Säljaktivitet - Kampanj, Mejl etc.',
  // 'Slug': 'Slug',
  // 'Subject': 'Ämne',
  // 'Email Templates': 'Mejl-mallar',
  // 'Revision Date': 'Revisionsdatum',
  // 'CPU': 'CPU',
  // 'Filename 1': 'Filnamn 1',
  // 'Filename 2': 'Filnamn 2',
  // 'Revisions': 'Revisioner',
  // 'Revision': 'Revision',
  // 'Upload new revision': 'Ladda upp ny revision',
  // 'Equipment ID': 'Utrustnings-ID',
  // '# CPUs': '# CPUer',
  // 'Create Equipment Specification': 'Skapa Maskinspecifikation',
  // 'Display': 'Display',
  // 'Styrkort': 'Styrkort',
  // 'Latest rev CPU 1': 'Senaste rev CPU 1',
  // 'Latest rev CPU 2': 'Senaste rev CPU 2',
  // 'Equipment Specifications': 'Maskinspecifikation',
  // 'Create specification': 'Skapa specifikation',
  // 'Old': 'Gammalt',
  // 'New': 'Nytt',
  // 'Create Update Entry': 'Skapa uppdateringsjobb',
  // 'Update Queue': 'Uppdateringskö',
  // 'Create update entry': 'Skapa uppdateringsjobb',
  '[Welcome Title]': 'Welcome, ',
  '[Welcome Body]': 'This portal gives you insights into the details of the welds that are performed in at your company. Use the menu on the left to navigate.',
  // 'Number of joints': 'Antal skarvar',
  // 'Dimension': 'Dimension',
  // 'Select a Machine ID': 'Välj ett Maskin-ID',
  // 'Choose the equipment related to your message (optional)': 'Välj den utrustning som ärendet rör (frivilligt)',
  // '-- Nothing Selected --': '-- Ingen vald --',
  // 'Message': 'Meddelande',
  // 'Write your message here': 'Skriv ditt meddelande här',
  // 'I want to send back the equipment': 'Jag vill skicka tillbaka utrustningen',
  // 'Contact Support': 'Kontakta Support',
  // 'Send message': 'Skicka meddelande',
  // 'Login': 'Logga in',
  // 'Logout': 'Logga ut',
  // 'Users': 'Användare',
  // 'Firmware Revisions': 'Mjukvaror',
  // 'Equipment Spec.': 'Maskinspec.',
  // 'Remote Update': 'Fjärruppdatering',
  // 'Dashboard': 'Dashboard',
  // 'Current': 'Nuvarande',
  // 'History': 'Historik',
  // 'Weld Report': 'Svetsrapport',
  // 'Support': 'Support',
  'temps': 'Temperatures °C',
  'timestamp': 'Timestamp',
  'mode': 'Mode',
  'alarm': 'Alarm',
  'channel': 'Channel',
  'dimension': 'Dimension',
  'joint_time_a': 'Total weld time',
  'u_mains': 'Voltage',
  'u_mains_min_max': 'Min/Max Voltage',
  'name': 'Name',
  'ALARM-0': 'No alarm',
  'ALARM-1': 'Faulty Converter',
  'ALARM-2': 'Log Memory Full',
  'ALARM-4': '10min Timeout',
  'ALARM-8': 'Tool Problem',
  'ALARM-16': 'Open Cable',
  'ALARM-32': 'Boost Timeout',
  'ALARM-64': 'Overheated',
  'ALARM-128': 'Shorted Cable',
  'TIME-min': 'min',
  'TIME-sec': 'sec',
  'TSC svets': 'Welding Machine',
  'bend': 'böj',
  'Joint Comment': 'Comment',
  'stored': 'Internal ID',
  'STOCK_AUDIT': 'Inventory Audit',
  'GENERAL_COMMENT': 'Note',
  'Krymp': 'Shrink',
  'processDone': 'Process done',
  'Skarv-ID': 'Weld ID'
}



// WEBPACK FOOTER //
// ./src/translations/en.js